import { GET_ASSETS } from '../../endpoints';
import makeAuthenticatedRequest from '../base-api';
import { IAsset } from '../../types';

const assetsQueryKey = ['assets'];

const getAssets = async (
  key: string | string[]
): Promise<{
  success: boolean;
  asset?: IAsset;
  message?: string;
}> => {
  try {
    const response = await makeAuthenticatedRequest(GET_ASSETS(key), {
      method: 'GET',
    });

    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message);
    }

    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export { getAssets, assetsQueryKey };
